import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee36ba1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sku-map-tool-tip-content"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "text-rt"
}

import { t } from '@/plugins/i18n'
import { calcCeil, calcJpyToRmb, formatMoneyDirection, showCurrentUnit } from '@/util/useYan'
import { formatMoney } from '@/plugins/utils'
import { computed } from 'vue'
import { isJA } from '@/store'
// minCount 最小起订量

export default /*#__PURE__*/_defineComponent({
  props: ['num', 'ladder', 'saleType', 'minCount', 'placement', 'sourceCountryInfo', 'product', 'hiddenRMB'],
  setup(__props) {

const props = __props

const unit = computed(() => {
  return showCurrentUnit(props.sourceCountryInfo.currency === 'KRW')
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "light",
    placement: __props.placement ?? 'right',
    "popper-class": "tool-tip-no-border",
    disabled: __props.saleType === 2 || !__props.ladder?.length
  }, {
    content: _withCtx(() => [
      (!(__props.saleType === 2 || !__props.ladder?.length))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.ladder, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["sku-map-item", { 'active': (__props.num >= item.count) && (__props.ladder.length === index + 1 || (__props.num < __props.ladder[index + 1]?.count)) }]),
                key: index
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('数量')) + " " + _toDisplayString((__props.minCount === 2 && item.isOnePsale) ? '=' : '≥') + " " + _toDisplayString(item.count), 1),
                (__props.product?.switchAllIncludePriceJp === 1 && _unref(isJA)())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createTextVNode(_toDisplayString(_unref(formatMoney)(item.allIncludePriceJp)) + "円 ", 1),
                      _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(calcJpyToRmb)(item.allIncludePriceJp)) + "元) ", 513), [
                        [_vShow, !__props.hiddenRMB]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_unref(formatMoney)(item.price)) + _toDisplayString(_unref(unit)) + " ", 1),
                      (props.sourceCountryInfo.currency !== 'KRW')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(calcCeil)(item.price,
                __props.sourceCountryInfo?.currencyCode ?? __props.sourceCountryInfo?.currency))) + ")", 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(calcCeil)(item.price,
                __props.sourceCountryInfo?.currencyCode ?? __props.sourceCountryInfo?.currency))) + ")", 1))
                    ]))
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["placement", "disabled"]))
}
}

})